import React, { useState } from 'react'
import {store} from '../../../stores/store'
import {FaChartLine, FaPlus, FaMinus, FaRegEye, FaRegEyeSlash, FaEye, FaEyeSlash} from 'react-icons/fa'

import './IndicatorsGroups.css'
import IndicatorsPool from '../../../js/IndicatorsPool';


function getAllChildrenIds(data) {
  let ids = [data.id]
  if(data.children) {
    data.children.forEach(c => {
      ids = ids.concat(getAllChildrenIds(c))
    })
  }
  return ids
}


function Group({data, visibleInds, togglable = true, onClick}) {


  // le dépliage
  const [showChildren, setshowChildren] = useState(false);
  function toggleChildren() {
    setshowChildren(!showChildren)
  }


  // affichage sur le graph
  const [childrenChartVisible, setChildrenChartVisible] = useState(false);

  const isVisible = visibleInds.indexOf(data.id) > -1

  function toggleVisibility() {
    if(!isVisible) {
      // if not visible, show me
      onClick([data.id], true)
    }
    else {
      if(data.children) {
        if (childrenChartVisible) {
          // on cache soi meme et les enfants
          hideAllChildren()
        }
        else {
          showAllChildren()
        }
      }
      else {
        onClick([data.id], false)
      }
    }
  }


  function showAllChildren() {
    let ids = getAllChildrenIds(data)
    onClick(ids,  true)
    setChildrenChartVisible(true)
  }
  function hideAllChildren() {
    let ids = getAllChildrenIds(data)
    onClick(ids, false)
    setChildrenChartVisible(false)
  }




  let indName = IndicatorsPool.getIndicator(data.id).title

  // let realIndValue = IndicatorsPool.getIndicatorValue(data.id, false)
  let indValue = IndicatorsPool.getIndicatorValue(data.id, true)

  let prevVal = parseFloat(store.indValuesHistory[store.indValuesHistory.length - 1][data.id])
  let floatIndValue = parseFloat(indValue)

  let colorClass = floatIndValue < prevVal ?  " red" : floatIndValue > prevVal ? " green" : ""
  if(store.yearNumber === 1) colorClass = ""

  return (
    <div className="indicators-group">

      <ul>
        <li>
          <div className="indicators-group-indicator-title">

            {data.children && data.children.length > 0 &&
            <div onClick={toggleChildren} className="toggle-children">{showChildren ? <FaMinus /> : <FaPlus />}</div>}

            <div className="ind-content">
              <span className="ind-name" title={data.id} >{indName}:</span>
              <span className={"ind-value " + colorClass}>{indValue}</span>
            </div>
            <div onClick={toggleVisibility}>
              {isVisible && !childrenChartVisible && <FaEye />}
              {isVisible && childrenChartVisible && <FaRegEye />}
              {!isVisible && <FaEyeSlash />}

            </div>
            {/* <div onClick={toggleChildrenVisibility}>{isVisible ? <FaRegEye /> : <FaRegEyeSlash />}</div> */}

          </div>

          {(showChildren && data.children) && data.children.map(c => {
            return (
              <div className="indicators-group-indicator-children" key={c.id}>
                <Group onClick={onClick} visibleInds={visibleInds} data={c} togglable={togglable} />

              </div>)
          })}
        </li>

      </ul>
      </div>
  )

}

function IndicatorsGroupsList({visibleInds, onClick}) {
  let inds = store.indicatorsTrees

  return (
    <>
      {inds.env.map(data => <Group onClick={onClick} visibleInds={visibleInds} data={data} key={data.id} />)}
      {inds.eco.map(data => <Group onClick={onClick} visibleInds={visibleInds} data={data} key={data.id} />)}
      {inds.soc.map(data => <Group onClick={onClick} visibleInds={visibleInds} data={data} key={data.id} />)}
    </>
  )
}

export default IndicatorsGroupsList